// Dashboard.js
import { Container, Grid, Box } from '@mui/material';
import { useAuth } from './AuthContext';
import SectorGrid from './SectorGrid';
import PromotionBanner from './PromotionBanner';
import DashboardText from './DashboardText';
import MarketIndicesOverview from './MarketIndicesOverview';
import DashboardActionGrid from './DashboardActionGrid';
import MiniPortfolioSummary from './miniPortfolio/MiniPortfolioSummary';
import MiniAlertsSummary from '../components/miniAlerts/MiniAlertsSummary';
import MiniNews from '../components/miniNews/MiniNews';
import MiniCongress from '../components/miniCongress/MiniCongress';
import MiniPopularScreens from '../components/miniPopularScreens/MiniPopularScreens';
import MiniMarketMovers from '../components/miniMovers/MiniMarketMovers';
// import FeatureAnnouncementBanner from './Featureannouncementbanner';

const Dashboard = () => {
  const { user } = useAuth();

  return (
    <div className="table-container">
      <PromotionBanner />
      {/*<FeatureAnnouncementBanner
        text="🔥 AI Portfolio Analysis: How Healthy Is Your Portfolio? Find Out Now"
        link="/portfolio"
      />  */}
      <Container maxWidth="xl">
        {/* SectorGrid component */}
        <SectorGrid />

        {/* Market Indices */}
        <Container maxWidth="md" sx={{ mt: 4 }}>
          <MarketIndicesOverview />
        </Container>

        {/* Dashboard Text */}
        <Container maxWidth="xl" sx={{ mt: 4 }}>
          <DashboardText />
        </Container>

        <MiniPopularScreens />

        {/* Portfolio and Alerts Side by Side */}
        <Box sx={{ mt: 4 }}>
          <Grid container spacing={3} alignItems="stretch">
            <Grid item xs={12} md={8} sx={{ display: 'flex', flexDirection: 'column' }}>
              <MiniPortfolioSummary userId={user._id} />
            </Grid>
            <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column' }}>
              <MiniAlertsSummary user={user} />
            </Grid>
          </Grid>
        </Box>

        {/* Dashboard Text */}
        <Box sx={{ mt: 2 }}>
          <MiniMarketMovers />
        </Box>

        {/* News and Congress Tracker Side by Side */}
        <Box sx={{ mt: 4 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <MiniNews />
            </Grid>
            <Grid item xs={12} md={4}>
              <MiniCongress />
            </Grid>
          </Grid>
        </Box>

        {/* Dashboard Action Grid at the bottom */}
        <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
          <DashboardActionGrid />
        </Container>
      </Container>
    </div>
  );
};

export default Dashboard;